<template>
  <div id="viewTokenCom" class="viewTokenCom">
    <el-dialog
        title="Token"
        :visible.sync="tokenDialog"
        :close-on-click-modal="false"
        :before-close="handleClose"
        width="30%"
        >
        <span class="viewtoken-tip">当前获取的viewToken有效期 <span style="color: red">10小时</span></span>
        <textarea id='textarea_token' class="textarea_token" :value='tokenData' type="text"/>
        <span slot="footer" class="dialog-footer">
        <el-button @click="tokenDialog = false">取 消</el-button>
        <el-button type="primary" @click="copyToken">复制</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import { getObjectViewToken } from 'src/utils/modelUtils';

export default {
    name: 'viewTokenCom',
    components: {
    },
    data() {
        return {
            tokenDialog: false,
            tokenData: '',
        };
    },
    mounted() {
    },
    methods: {
        Open() {
            const _self = this;
            _self.tokenDialog = true; //  打开模态框
            getObjectViewToken().then(res => {
                _self.tokenData = res.data.newToken;
            });
        },
        handleClose() {
            this.tokenData = '';
            this.tokenDialog = false; //  关闭模态框
        },
        copyToken() {
            const textarea = document.getElementById('textarea_token');
            textarea.value = this.tokenData;
            textarea.select();
            if (document.execCommand('Copy', 'false', null)) {
                this.$message('复制成功');
            }
        },
    },
};
</script>
<style scoped lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/variable'
  #viewTokenCom >>> .el-dialog__body
   padding-top 5px
  .viewtoken-tip
    margin-bottom: 15px;
    font-size: 16px;
    display: block;
  .textarea_token
    width: 98%
    height: 160px
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/viewTokenCom.vue